<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية"><div class="section level2" id="narcissistic" style="padding-top:130px">
<p><span dir="rtl">لذا لا ترفعه أكثر من اللازم، فقط أبقِه قريباً من رأسك قليلاً،</span></p>
<p><span dir="rtl">عندما يسقط لن ينجم أي جرح جراء ذلك، وقتها تستطيع رفعه من جديد؛</span></p>
<p><span dir="rtl">بأخذ الأعمدة القوية بعين الاعتبار... ستمتلك الخبرة.</span></p>
<p style="text-align:center; direction:ltr">So make expectations but not too much high in case they fall upon you won’t hurt you, and then you can make another high expectation so high with a trust this time.</p>
<br/><p style="text-align:center">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?6150b106